import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ForexPairs = lazy(() => import('../../pages/ForexPairs/ForexPairsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<ForexPairs />} />
    </Routes>
  );
}

export default PagesRoute;
